/**
 * Mobile Account Page
 * Shows: Default League setting, user profile placeholder
 */
import React, { useState, useEffect } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { leaguesAPI } from '../../../services/apiService';
import useDefaultLeague from '../../../hooks/useDefaultLeague';

function MobileAccount({ onNavigate = null }) {
  const [leagues, setLeagues] = useState([]);

  useEffect(() => {
    const fetchLeagues = async () => {
      try {
        const res = await leaguesAPI.getMyLeagues();
        if (res?.success && res.leagues) {
          setLeagues(res.leagues);
        }
      } catch (err) {
        console.error('Error fetching leagues:', err);
      }
    };
    fetchLeagues();
  }, []);

  const { defaultLeagueId, setDefaultLeagueId } = useDefaultLeague(leagues, true);

  const handleDefaultLeagueChange = (value) => {
    setDefaultLeagueId(value || null);
  };

  return (
    <div style={{
      padding: '8px',
      backgroundColor: 'transparent',
    }}>
      <h1 style={{
        fontSize: '24px',
        fontWeight: '700',
        color: dynastyTheme.tokens.colors.neutral[50],
        marginBottom: '24px',
      }}>
        Account
      </h1>

      {/* Default League Setting */}
      <div style={{
        backgroundColor: dynastyTheme.tokens.colors.neutral[800],
        borderRadius: '10px',
        padding: '16px',
        border: `1px solid ${dynastyTheme.tokens.colors.neutral[700]}`,
        marginBottom: '16px',
      }}>
        <h2 style={{
          fontSize: '16px',
          fontWeight: '700',
          color: dynastyTheme.tokens.colors.neutral[50],
          marginBottom: '12px',
        }}>
          Default League
        </h2>
        <p style={{
          fontSize: '13px',
          color: dynastyTheme.tokens.colors.neutral[400],
          marginBottom: '12px',
          lineHeight: '1.4',
        }}>
          Quick Actions on the home screen will use this league. Choose "Always ask" to pick each time.
        </p>

        <select
          value={defaultLeagueId}
          onChange={(e) => handleDefaultLeagueChange(e.target.value)}
          style={{
            width: '100%',
            padding: '10px 12px',
            backgroundColor: 'transparent',
            color: dynastyTheme.tokens.colors.neutral[50],
            border: `1px solid ${dynastyTheme.tokens.colors.neutral[700]}`,
            borderRadius: '8px',
            fontSize: '14px',
            outline: 'none',
            WebkitAppearance: 'none',
            appearance: 'none',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2378716c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 12px center',
          }}
        >
          <option value="">Always ask</option>
          {leagues.map(league => (
            <option key={league.league_id} value={league.league_id}>
              {league.league_name}
            </option>
          ))}
        </select>
      </div>

      {/* 9l.2: Watch List entry — opens MobileWatchList via activeTab='watchlist' */}
      <button
        type="button"
        onClick={() => onNavigate && onNavigate('watchlist')}
        style={{
          width: '100%',
          backgroundColor: dynastyTheme.tokens.colors.neutral[800],
          borderRadius: '10px',
          padding: '16px',
          border: `1px solid ${dynastyTheme.tokens.colors.neutral[700]}`,
          marginBottom: '16px',
          textAlign: 'left',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        aria-label="Open Watch List"
      >
        <div>
          <div style={{
            fontSize: '16px',
            fontWeight: '700',
            color: dynastyTheme.tokens.colors.neutral[50],
            marginBottom: '4px',
          }}>
            ☆ Watch List
          </div>
          <div style={{
            fontSize: '12px',
            color: dynastyTheme.tokens.colors.neutral[400],
          }}>
            Players you're tracking
          </div>
        </div>
        <div style={{ fontSize: '16px', color: dynastyTheme.tokens.colors.neutral[400] }}>
          ›
        </div>
      </button>

      {/* Placeholder sections */}
      <div style={{
        backgroundColor: dynastyTheme.tokens.colors.neutral[800],
        borderRadius: '10px',
        padding: '16px',
        border: `1px solid ${dynastyTheme.tokens.colors.neutral[700]}`,
      }}>
        <p style={{
          fontSize: '14px',
          color: dynastyTheme.tokens.colors.neutral[400],
        }}>
          More account settings coming soon:
        </p>
        <ul style={{
          marginTop: '10px',
          paddingLeft: '8px',
          color: dynastyTheme.tokens.colors.neutral[300],
          fontSize: '13px',
          lineHeight: '1.8',
        }}>
          <li>User profile</li>
          <li>Notification preferences</li>
          <li>Logout</li>
        </ul>
      </div>
    </div>
  );
}

export default MobileAccount;
